// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
:root {
  --tf-spacing-lg: 1.5rem;
  --tf-spacing-md: 1rem;
  --tf-spacing-sm: 0.5rem;
  --tf-font-family: 'Source Sans Pro', sans-serif;
  --tf-font-size-lg: 1.125rem;
  --tf-font-size-md: 1rem;
  --tf-font-size-sm: 0.875rem;
  --tf-card-radius: 0.625rem;
  --tf-card-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  --tf-card-bg: var(--color-grey-100);
  --tf-card-bg: var(--color-grey-100);
  --tf-card-border: 1px solid var(--color-grey-91);
  --tf-card-border: 1px solid var(--color-grey-91);
}

/* TimeFrame Item Container */
.timeframe-item {
  margin: 8px 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.timeframe-item-content {
  display: flex;
  flex: 1;
  background: #ffffff;
  border: 1px solid #dce0e8;
  border-radius: 5px;
  padding: 0 0 0 8px;
}

/* Main Content Area */
.timeframe-main-info {
  flex: 1;
  padding: 16px;
}

.timeframe-row {
  display: flex;
  align-items: flex-start;
}

/* Info Groups */
.info-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.info-title {
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--tf-font-family);
  font-weight: 600;
  font-size: 14px;
  line-height: 1.14;
  color: #4d5674;
}

.info-content {
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--tf-font-family);
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  color: #4d5674;
}

.info-group-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 3;
  justify-content: center;
  padding-left: 24px;
}

/* Row Layout */
.timeframe-first-row {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: center;
  width: 100%;
}

.timeframe-second-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  padding-top: 16px;
}

/* Hours and Sources */
.timeframe-hours {
  display: flex;
  gap: 24px;
  flex: 1;
}

.timeframe-sources {
  display: flex;
  gap: 24px;
  flex: 2;
}

.source-group {
  display: flex;
  flex-direction: column;
}

.source-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 6px;
  background: var(--color-grey-96);
  background: var(--color-grey-96);
  border-radius: 3px;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--tf-font-family);
  font-weight: 600;
  font-size: 14px;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

/* Dividers */
.two-sides-vertical-divider {
  border-right: 1px solid var(--color-grey-91);
  border-right: 1px solid var(--color-grey-91);
  border-left: 1px solid var(--color-grey-91);
  border-left: 1px solid var(--color-grey-91);
}

/* Menu */
.menu-container {
  position: relative;
  padding: 8px;
}

.menu-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 20px;
}

.menu-button:hover,
.menu-button.active {
  background: rgba(0, 0, 0, 0.05);
}

.menu-button img {
  width: 16px;
  height: 16px;
}

/* Responsive */
@media (max-width: 900px) {
  .timeframe-item {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }
}

.radio-button-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  background: var(--color-white);
  background: var(--color-white);
  box-sizing: border-box;
  position: relative;
  margin-right: 0;
}

.radio-button-box.active {
  border: 1px solid var(--color-primary-idel);
  border: 1px solid var(--color-primary-idel);
}

.radio-button-input {
  opacity: 0;
  width: 16px;
  height: 16px;
  margin: 0;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
}

.radio-button-active-circle {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-primary-idel);
  background: var(--color-primary-idel);
}

.no-time-frames {
  background: var(--color-grey-96);
  background: var(--color-grey-96);
  width: 800px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px;
}

.no-time-frames-text {
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: var(--color-grey-71);
  color: var(--color-grey-71);
  /* text-align: center;
  align-self: center;
  justify-self: center; */
}
`, "",{"version":3,"sources":["webpack://./app/styles/editField/TimeFrameCard.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,+CAA+C;EAC/C,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,+CAA+C;EAC/C,mCAAmC;EAAnC,mCAAmC;EACnC,gDAAgD;EAAhD,gDAAgD;AAClD;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,0CAAkC;EAAlC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0CAAkC;EAAlC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,OAAO;EACP,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAAhC,gCAAgC;EAChC,kBAAkB;EAClB,0CAAkC;EAAlC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAA3B,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,4CAA4C;EAA5C,4CAA4C;EAC5C,2CAA2C;EAA3C,2CAA2C;AAC7C;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EAAtC,sCAAsC;EACtC,8BAA8B;EAA9B,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EAArC,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAAhC,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAA3B,2BAA2B;EAC3B;;yBAEuB;AACzB","sourcesContent":["/* Variables */\n:root {\n  --tf-spacing-lg: 1.5rem;\n  --tf-spacing-md: 1rem;\n  --tf-spacing-sm: 0.5rem;\n  --tf-font-family: 'Source Sans Pro', sans-serif;\n  --tf-font-size-lg: 1.125rem;\n  --tf-font-size-md: 1rem;\n  --tf-font-size-sm: 0.875rem;\n  --tf-card-radius: 0.625rem;\n  --tf-card-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  --tf-card-bg: var(--color-grey-100);\n  --tf-card-border: 1px solid var(--color-grey-91);\n}\n\n/* TimeFrame Item Container */\n.timeframe-item {\n  margin: 8px 0;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.timeframe-item-content {\n  display: flex;\n  flex: 1;\n  background: #ffffff;\n  border: 1px solid #dce0e8;\n  border-radius: 5px;\n  padding: 0 0 0 8px;\n}\n\n/* Main Content Area */\n.timeframe-main-info {\n  flex: 1;\n  padding: 16px;\n}\n\n.timeframe-row {\n  display: flex;\n  align-items: flex-start;\n}\n\n/* Info Groups */\n.info-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.info-title {\n  font-family: var(--tf-font-family);\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.14;\n  color: #4d5674;\n}\n\n.info-content {\n  font-family: var(--tf-font-family);\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1;\n  color: #4d5674;\n}\n\n.info-group-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 3;\n  justify-content: center;\n  padding-left: 24px;\n}\n\n/* Row Layout */\n.timeframe-first-row {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  justify-content: center;\n  width: 100%;\n}\n\n.timeframe-second-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  padding-top: 16px;\n}\n\n/* Hours and Sources */\n.timeframe-hours {\n  display: flex;\n  gap: 24px;\n  flex: 1;\n}\n\n.timeframe-sources {\n  display: flex;\n  gap: 24px;\n  flex: 2;\n}\n\n.source-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.source-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 6px;\n  background: var(--color-grey-96);\n  border-radius: 3px;\n  font-family: var(--tf-font-family);\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--color-grey-45);\n}\n\n/* Dividers */\n.two-sides-vertical-divider {\n  border-right: 1px solid var(--color-grey-91);\n  border-left: 1px solid var(--color-grey-91);\n}\n\n/* Menu */\n.menu-container {\n  position: relative;\n  padding: 8px;\n}\n\n.menu-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 20px;\n}\n\n.menu-button:hover,\n.menu-button.active {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.menu-button img {\n  width: 16px;\n  height: 16px;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .timeframe-item {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n  }\n}\n\n.radio-button-box {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 1px solid var(--color-grey-91);\n  background: var(--color-white);\n  box-sizing: border-box;\n  position: relative;\n  margin-right: 0;\n}\n\n.radio-button-box.active {\n  border: 1px solid var(--color-primary-idel);\n}\n\n.radio-button-input {\n  opacity: 0;\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  position: absolute;\n  left: 0;\n  top: 0;\n  cursor: pointer;\n}\n\n.radio-button-active-circle {\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--color-primary-idel);\n}\n\n.no-time-frames {\n  background: var(--color-grey-96);\n  width: 800px;\n  height: 68px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 22px;\n}\n\n.no-time-frames-text {\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 24px;\n  color: var(--color-grey-71);\n  /* text-align: center;\n  align-self: center;\n  justify-self: center; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
